import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiConfiguration } from '../models/api-configuration.model';
import { ConfigurationApiService } from './configuration-api.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationStateService {
  private isLoading$ = new BehaviorSubject<boolean>(true);
  private apiConfiguration: ApiConfiguration;

  constructor(private readonly api: ConfigurationApiService) {}

  init(): void {
    this.api.getConfiguration().subscribe((configuration) => {
      this.apiConfiguration = configuration;
      this.isLoading$.next(false);
    });
  }

  getConfigurationLoading(): Observable<boolean> {
    return this.isLoading$.asObservable();
  }

  getConfiguration(): ApiConfiguration {
    return this.apiConfiguration;
  }
}
